// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/CanelaText-Black-App.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/CanelaText-Black-Web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/CanelaText-Black-Web.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Canela-Black';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: 'Poppins-Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}
@font-face {
    font-family: 'Poppins-SemiBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}

.snackbar-medium-container
{
    width: 100%;
    align-items: unset;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B;+DAC6D;IAC7D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,+DAAyD;AAC7D;;AAEA;IACI,sBAAsB;IACtB,+DAA0D;AAC9D;AACA;IACI,+BAA+B;IAC/B,+DAA2D;AAC/D;;AAEA;;IAEI,WAAW;IACX,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: 'Canela-Black';\n    src: url('./fonts/CanelaText-Black-App.ttf') format('truetype'), url('./fonts/CanelaText-Black-Web.woff') format('woff'),\n        url('./fonts/CanelaText-Black-Web.woff2') format('woff2');\n    font-weight: 900;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Poppins-Medium';\n    src: url('./fonts/Poppins-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('./fonts/Poppins-Regular.ttf') format('truetype');\n}\n@font-face {\n    font-family: 'Poppins-SemiBold';\n    src: url('./fonts/Poppins-SemiBold.ttf') format('truetype');\n}\n\n.snackbar-medium-container\n{\n    width: 100%;\n    align-items: unset;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
